/**
 * The line under the Board's column titles while the day plan has not
 * answered (23/10/2026): a bar sweeping its top edge and what is coming —
 * or, when it failed, what is unknown and Retry. Nothing once it is there.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';

import { Button } from '@/components/ui';

import type { BoardPreviewState } from './board-preview-state';

export const BoardPreviewBar: FC<{ state: BoardPreviewState; onRetry?: () => void }> = ({ state, onRetry }) => {
  if (state === 'failed')
    return (
      <div role="alert" className="flex items-center gap-2 border-b border-warning/30 bg-warning/5 px-5 py-2 text-xs text-warning" data-testid="board-preview-failed">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
        <span className="grow">Today&apos;s plan did not load — lists, progress and state are unknown.</span>
        {onRetry ? (
          <Button variant="outline" size="sm" className="h-7" onClick={onRetry}>
            Retry
          </Button>
        ) : null}
      </div>
    );
  if (state !== 'loading') return null;
  return (
    <div role="status" aria-live="polite" className="relative flex items-center gap-2 border-b border-border/40 bg-primary/[0.03] px-5 py-2 text-xs text-muted-foreground" data-testid="board-preview-loading">
      <span className="pointer-events-none absolute inset-x-0 top-0 h-0.5 overflow-hidden" aria-hidden>
        <span className="block h-full w-1/3 animate-dg-indeterminate bg-primary/70 motion-reduce:animate-none" />
      </span>
      <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-primary motion-reduce:animate-none" aria-hidden />
      <span>Loading today&apos;s plan — lists, progress and state fill in as soon as the planner answers (up to a minute on a busy tracker).</span>
    </div>
  );
};
